import * as Yup from "yup";

import i18n from "../../translations/i18n";

import { EntryLength } from "./articleForm.constants";

export const ArticleSchema = Yup.object().shape({
  image: Yup.string()
    .required(i18n.t("validationMessage.required")),
  title: Yup.string()
    .trim()
    .required(i18n.t("validationMessage.required"))
    .max(EntryLength.Title, i18n.t("validationMessage.maxLength")),
  content: Yup.string()
    .trim()
    .stripMarkdown()
    .required(i18n.t("validationMessage.required"))
    .max(EntryLength.ArticleFull, i18n.t("validationMessage.maxLength")),
  visibility: Yup.array().min(1, i18n.t("validationMessage.atLeastOneOption")),
});
